// useLeaflet — carga diferida del bootstrap de Leaflet en un solo lugar.
//
// leaflet.markercluster y leaflet.heat son bundles UMD que leen el objeto
// global `L`: importarlos como chunks dinámicos separados no funciona (los
// plugins nunca ven Leaflet). lib/leaflet-bootstrap importa Leaflet primero
// (estático), los plugins parchean esa misma instancia y recién entonces
// expone L. Este hook lazy-importa ese módulo (chunk aparte) y protege el
// setState con `disposed` para componentes que se desmontan antes de que
// termine la carga.
import { useEffect, useState } from 'react';

export type LeafletModule = typeof import('leaflet');

export function useLeaflet(enabled = true): LeafletModule | null {
  const [L, setL] = useState<LeafletModule | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let disposed = false;
    import('./leaflet-bootstrap').then(({ default: leaflet }) => {
      if (!disposed) setL(leaflet);
    });
    return () => {
      disposed = true;
    };
  }, [enabled]);

  return L;
}
